import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-item {
    display: flex;
    margin-bottom: 8px;
    flex-wrap: wrap;
    .ant-form-item {
      margin-bottom: 0;
      &.input-onsite {
        display: flex;
        align-items: center;
      }
    }
    .ant-form-item-control {
      max-width: 400px;
    }
  }

  .titleSiteName {
    margin-left: 8px;
    color: #000000;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }
  .group-input {
    padding: 0 24px 0 24px;
    .box-select-time {
      display: flex;
      flex-wrap: wrap;
      .input-time {
        margin-bottom: 0;
        .ant-form-item-no-colon {
          margin-top: 4px;
        }
        .ant-form-item-control {
          width: 176px;
        }
        .ant-form-item-control-input-content {
          flex: auto;
          display: flex;
          max-width: 100%;
        }
      }
    }
    .ant-form-item {
      flex-direction: row;
      display: flex;
      &.note-field {
        margin-bottom: 0;
      }
      .ant-form-item-label {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0;
        .ant-form-item-no-colon {
          color: #000000;
          width: 110px;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
        }
      }
    }
    .select-field {
      min-width: 400px;
    }
  }
  .ant-modal-footer {
    margin-top: 16px !important;
    .ant-btn-primary {
      margin-left: 16px !important;
    }
  }

  .select-date {
    width: 177px;
  }
  .select-time {
    width: 80px;
  }
  .center-text {
    margin-top: 4px;
    padding: 0 6px 0 6px;
  }
  .center-text-separate {
    margin-top: 4px;
    padding: 0 16px 0 16px;
  }
  .custom-mess-error {
    display: flex;
    flex-direction: column;
    .custom-mess-error-2 {
      display: flex;
      flex-direction: row;
    }
    .mess-error {
      color: #e65050;
    }
  }
`;

export const HeaderStyle = styled.div`
  display: flex;
  flex-direction: row;
  img {
    margin-right: 16px;
  }
`;
